import { Component, OnInit } from '@angular/core';
import { TagService } from '../shared/services/tag.service';
import { ApiService } from '../shared/services/api.service';
import { CourseService } from '../shared/services/course.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Tag } from '../shared/models/tag.model';
import { TagCategory } from '../shared/models/tag-category.model';

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss']
})

export class TagComponent implements OnInit {

    constructor(
        private tagService: TagService,
        private dataService: ApiService,
        private courseService: CourseService,
        private router: Router,
        private route: ActivatedRoute
        
        ) 
        {
    }

    tagCategories: TagCategory[] = new Array<TagCategory>();
    selectedTagsFromCategories: TagCategory[] = new Array<TagCategory>();
    tabSelected: boolean;
    totalTagSelectedCount: number = 0;
    exceedMax: boolean = false;

    ngOnInit(): void {
        this.getTagCategories();     
    }

    getTagCategories(): void {
        this.courseService.getCoursesAndTags().then(res => {
            this.tagCategories = this.tagService.populatedTagCategories;
            this.selectedTagsFromCategories = this.tagCategories;
        });
    }

    selectTab(tagCategory: TagCategory): void {
        this.tagCategories.forEach((tagCat, index, array) => {
            tagCat.tabSelected = false;
        });
        tagCategory.tabSelected = true;   
    }

    goToCorrectCoursesView(): void{
        let view;

         // reset selected courses and course levels
        let selectedCourses = this.courseService.getSelectedCourses();  

        // set which tab is enabled, based on course relevancy
        if(selectedCourses.find(el => el.relevancy > 0)) {
            view = 'tagged';
        } else{
            view = 'all';
        }

        this.router.navigate(['/courses/', view]);
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/tag/tag.component.ts